module.exports = __webpack_public_path__ + "assets/img/Ladbrokes.45be56ae.png";